import React, { useEffect, useState } from "react";
import Divider from "@mui/material/Divider";
import { makeStyles } from "@mui/styles";
import { Box, Grid, Select, Typography } from "@mui/material";
import Medical from "./Medical";
import Finance from "./Finance";
import Doctor from "./Doctor";
import RefreshIcon from "../../../Assets/Table/RefreshIcon";
import { genericFetchData } from "../../../Services/Service";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";

const tableHead = {
  fontSize: "14px",
  color: "#4C5A6A",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  gap: 1,
};

const useStyles = makeStyles({
  customDivider: {
    backgroundColor: "#E7EEF8",
  },
});

const ApprovalsPending = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [taskList, setTaskList] = useState([]);
  const [selectedTable, setSelectedTable] = useState("HOSPITAL");
  const [keyword, setKeyword] = useState("");

  const [table, setTable] = useState(
    <Medical tableHead={tableHead} taskList={taskList} />
  );

  const sections = [
    {
      id: 1,
      title: "HOSPITAL",
    },
    {
      id: 2,
      title: "DOCTOR",
    },
  ];

   useEffect(() => {
     setTaskList([]);
   }, [keyword, selectedTable]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await genericFetchData(
        keyword
          ? `/data/pending?pageNo=${page}&pageSize=12&dataType=${selectedTable}&keyword=${keyword}`
          : `/data/pending?pageNo=${page}&pageSize=12&dataType=${selectedTable}`,
        "GET"
      );
      const responseData = await response.json();
      setTaskList(responseData?.responseList);
    };
    fetchData();
  }, [selectedTable,keyword]);

  const loadAllTask = async () => {
    const nextPage = page + 1;

    try {
      const response = await genericFetchData(
        keyword
          ? `/data/pending?pageNo=${nextPage}&pageSize=10&dataType=${selectedTable}&keyword=${keyword}`
          : `/data/pending?pageNo=${nextPage}&pageSize=10&dataType=${selectedTable}`,
        "GET"
      );
      const responseData = await response.json();

      setTaskList((prevList) => [...prevList, ...responseData?.responseList]);
      setPage(nextPage);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    switch (selectedTable) {
      case "HOSPITAL":
        setTable(
          <Medical
            tableHead={tableHead}
            loadAllTask={loadAllTask}
            taskList={taskList}
          />
        );
        setPage(0);
        break;
      case "DOCTOR":
        setTable(
          <Doctor
            tableHead={tableHead}
            loadAllTask={loadAllTask}
            taskList={taskList}
          />
        );
        setPage(0);
        break;
      case "Insurance":
        setTable(<Finance tableHead={tableHead} />);
        break;
      case "Ops Admin":
      case "Super Admin":
        setTable(null);
        break;
      default:
        setTable(
          <Medical
            tableHead={tableHead}
            loadAllTask={loadAllTask}
            taskList={taskList}
          />
        );
        setPage(0);
        break;
    }
  }, [selectedTable, taskList]);

  return (
    <Box
      sx={{
        backgroundColor: "#F9FBFC",
        width: "77%",
        height: "94vh",
        margin: "5px  25px",
        borderRadius: "20px",
      }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "40px 40px  10px 30px",
        }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "22px",
          }}>
          <Typography sx={{ fontWeight: 600, fontSize: "22px" }}>
            Approvals Pending
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              width: "30px",
              height: "30px",
              borderRadius: "8px",
              bgcolor: "#ECF1F5",
            }}>
            <RefreshIcon />
          </Box>
        </Box>

        {/* filters */}

        <Box
          sx={{
            display: "flex",
            flex: 1,
            px: 2,
            justifyContent: "flex-end",
            gap:2,
            alignItems: "center",
          }}>
         
          
          <Grid>
            <SearchBar
              width={230}
              placeHolder={"Search Name"}
              onChagevalue={(e) => setKeyword(e.target.value)}
            />
          </Grid>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {/* <ApprovalPendingTab/> */}
            {sections.map((section) => {
              return (
                <button
                  key={section.id}
                  style={{
                    backgroundColor:
                      selectedTable === section.title ? "#414851" : "#ECF1F5",
                    height: "36px",
                    minWidthidth: "84px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    border: "none",
                    color:
                      selectedTable === section.title ? "white" : "#2E2E2E",
                    fontSize: "13px",
                    letterSpacing: ".3px",
                    padding: "5px 15px",
                  }}
                  onClick={() => {
                    setSelectedTable(section.title);
                    setTaskList([]);
                    setPage(0);
                  }}>
                  {section.title}
                </button>
              );
            })}
          </Box>
        </Box>
      </Box>
      <Divider variant="middle" classes={{ root: classes.customDivider }} />
      {table}
    </Box>
  );
};

export default ApprovalsPending;
